import { exclamationMarkTriangle32 } from "@esri/calcite-ui-icons";

import { useTranslation } from "react-i18next";

interface AlertProps {
  message: string;
}

export default function SimpleAlert({ message }: AlertProps) {
  return (
    <div className="bg-white py-6 px-8 border-l-[5px] border-[#0079c1]">
      <div className="max-w-screen-xl mx-auto container flex flex-wrap items-center md:flex-nowrap mx-auto">
        <div className="text-gray-700">
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
}
